import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0203 from "../lesson-03/lesson";
import lesson0205 from "../lesson-05/lesson";
import lesson0222 from "../lesson-22/lesson";
import lesson0223 from "../lesson-23/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "a3bae18d-cdb0-43eb-9692-111b6540aeb2",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0203),
    lesson: lesson0203,
  },
  {
    id: "48609876-3854-409d-9bd4-cff6921167d8",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0205),
    lesson: lesson0205,
  },
  {
    id: "4e2a1ad4-ec6f-43aa-a2d7-e9ad01bc3b0b",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0222),
    lesson: lesson0222,
  },
  {
    id: "1ee6d8c6-ce7d-4096-ba23-f7a8ccd655e0",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0223),
    lesson: lesson0223,
  },
];

export default lessonLinks;
